export default __webpack_public_path__ + "static/RootSans-4LightItalic-9c9531be9d4ee9308aa9cbc4702cd747.woff";